var map = {
	"./card_icon_v1_all.svg": "650a",
	"./card_icon_v1_amex.svg": "c1de",
	"./card_icon_v1_discover.svg": "e34a",
	"./card_icon_v1_jcb.svg": "95a8",
	"./card_icon_v1_mastercard.svg": "9a31",
	"./card_icon_v1_visa.svg": "c028"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b50";